import * as React from 'react';
import { Button } from '@/components/index';
import { Radio, Input, Space } from 'antd';
import { useIntl, useLocation } from 'umi';
import classnames from 'classnames/bind';
import { inject } from 'mobx-react';
import RTCModel from '@/models/rtc';
import UserModel from '@/models/user';
import Meeting from '@/models/meeting';
import Style from './index.less';
import { elkReport } from '@/utils/elkReport';

export { default as FeedbackPanelPopover } from './Popover';

const { TextArea } = Input;

const $c = classnames.bind(Style);

const feedbackMap: Record<number, { textKey: string; submitText: string }> = {
  100: {
    textKey: 'OTHER',
    submitText: '其他',
  },
  1: {
    textKey: 'FEEDBACK1',
    submitText: '无法加入会议',
  },
  2: {
    textKey: 'FEEDBACK2',
    submitText: '无法开麦',
  },
  3: {
    textKey: 'FEEDBACK3',
    submitText: '无法开启摄像头',
  },
  4: {
    textKey: 'FEEDBACK4',
    submitText: '音频问题',
  },
  5: {
    textKey: 'FEEDBACK5',
    submitText: '视频问题',
  },
  6: {
    textKey: 'FEEDBACK6',
    submitText: '屏幕共享问题',
  },
};

const feedbackListMap: Record<string, number[]> = {
  ready: [1, 2, 3],
  meeting: [4, 5, 6],
};

interface Props {
  meetingNumber?: number;
  createdTime?: number;
  RTCInstance?: RTCModel;
  meeting?: Meeting;
  user?: UserModel;
  type?: string;
  onSubmit?(): void;
}

const FeedbackPanel = inject(({ store }) => {
  return {
    RTCInstance: store.rtc,
    user: store.user,
    meeting: store.meeting,
  };
})((props: any) => {
  const { meeting, type = 'ready', onSubmit } = props;
  const { formatMessage: $i } = useIntl();
  const [value, setState] = React.useState(0);
  const [otherInput, setOtherInput] = React.useState('');

  React.useEffect(() => {}, []);

  const feedbackList = React.useMemo(() => {
    return feedbackListMap[type] || [];
  }, [type]);

  const onChange = React.useCallback(
    (e) => {
      console.log(e);
      setState(e.target.value);
    },
    [value]
  );

  const submit = React.useCallback(() => {
    elkReport({ type: '反馈成功', logData: { meetingInfo: meeting?.info, otherText: otherInput } });
    setState(0);
    setOtherInput('');
    onSubmit?.();
  }, [value, otherInput]);

  const ableSubmit = React.useMemo(() => {
    return ![0, 100].includes(value) || (value === 100 && otherInput);
  }, [value, otherInput]);

  return (
    <div className={$c('feedback-panel')} onClick={(e) => e.nativeEvent.stopImmediatePropagation()}>
      <div className={$c('header')}>{$i({ id: 'WHAT_PROBLEM' })}</div>
      <Radio.Group
        onChange={onChange}
        value={value}
        buttonStyle="solid"
        className={$c('radio-group')}
      >
        <Space direction="vertical" className={$c('radio-group-space')}>
          {feedbackList.map((i: number) => {
            return (
              <Radio key={i} value={i} className={$c('radio')}>
                {$i({ id: feedbackMap[i]?.textKey })}
              </Radio>
            );
          })}
          <Radio value={100} className={$c('radio', { other: value === 100 })}>
            {value === 100 ? (
              <TextArea
                className={$c('text-area')}
                placeholder={$i({ id: 'PBDYP' })}
                autoSize={{ minRows: 1, maxRows: 6 }}
                autoFocus
                value={otherInput}
                onChange={(e) => setOtherInput(e.target.value)}
              />
            ) : (
              $i({ id: 'OTHER' })
            )}
          </Radio>
        </Space>
      </Radio.Group>
      <div className={$c('btn-box')}>
        <Button
          className={$c('submit-btn')}
          type="primary"
          disabled={!ableSubmit}
          onClick={submit}
          size={window.isMobile ? 'large' : 'middle'}
          block={window.isMobile}
        >
          {$i({ id: 'SUBMIT' })}
        </Button>
      </div>
    </div>
  );
});

export default FeedbackPanel;
